import Vue from 'vue';
import api from '@/api';
import VueLazyload from 'vue-lazyload';
import { PRODUCT_ID } from '@/config/constants';
import App from './App';
import router from './router';
import store from './store';
import '@/utils/antdv';
import '@/utils/permission';
import '@/styles/index.less';

// 引入json格式化
import JsonViewer from 'vue-json-viewer';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
Vue.config.productionTip = false;
Vue.prototype.$http = api;
Vue.prototype.$productId = PRODUCT_ID;
Vue.use(VueLazyload, {
  lazyComponent: true
});
Vue.use(JsonViewer);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');